import {NgModule, Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'filterDynamicField',
    standalone: false
})
export class FilterDynamicField implements PipeTransform {

    transform(fields: any[], displayFields: string[]): any {
        if (!fields || !displayFields) {
            return fields;
        }

        const filteredFields = fields.filter(item => displayFields.includes(item.questionFieldName));
        return this.sortFields(filteredFields, displayFields);
    }

    private sortFields(fields: any[], displayFields: string[]): any[] {
        return fields.sort((a, b) => {
            const indexA = displayFields.indexOf(a.questionFieldName);
            const indexB = displayFields.indexOf(b.questionFieldName);
            return indexA - indexB;
        });
    }
}

@NgModule({
    declarations: [FilterDynamicField],
    exports: [FilterDynamicField],
})
export class FilterDynamicFieldModule {}
